// extracted by mini-css-extract-plugin
module.exports = {"summaryQuestion":"SummaryQuestion_summaryQuestion__20wkH"};